export {};
//# sourceMappingURL=resourceUtils.js.map